<template>
  <div class="col-12 utility-bar p-1">
  </div>
</template>

<script>
export default {};
</script>
